// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"i_-z"};